const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<figure>
  <div class="_demo-c-logo-alignment">
    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/logo/logo.twig`, new Map([[`src`, `/media/logos/walmart.svg`], [`alt`, `Walmart`], [`width`, 176], [`height`, 42]]), false, false, 3));
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/logo/logo.twig`, new Map([[`src`, `/media/logos/obama.svg`], [`alt`, `Obama ’08`], [`width`, 171], [`height`, 30], [`scale`, (((context.has(`align`) ? context.get(`align`) : null)) ? (0.8) : (``))]]), false, false, 9));
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/logo/logo.twig`, new Map([[`src`, `/media/logos/pleasantest.svg`], [`alt`, `Pleasantest`], [`width`, 180], [`height`, 58], [`scale`, (((context.has(`align`) ? context.get(`align`) : null)) ? (1.25) : (``))], [`align`, (((context.has(`align`) ? context.get(`align`) : null)) ? (`end`) : (``))]]), false, false, 16));
                this.echo(`  </div>
  <figcaption>
    Logos with `);
                if ( !(context.has(`align`) ? context.get(`align`) : null)) {
                    this.echo(`no`);
                }
                this.echo(` alignment options set.
  </figcaption>
</figure>
`);
            }

            getTemplateName() {
                return `11d54dc0ea9aa33bc57c34ab64ccfc842d3c610df4c9f1b4dd842b3e9a6fadf4`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `11d54dc0ea9aa33bc57c34ab64ccfc842d3c610df4c9f1b4dd842b3e9a6fadf4`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '11d54dc0ea9aa33bc57c34ab64ccfc842d3c610df4c9f1b4dd842b3e9a6fadf4');

let template = env.loadTemplate('11d54dc0ea9aa33bc57c34ab64ccfc842d3c610df4c9f1b4dd842b3e9a6fadf4');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/logo/demo/alignment.twig", args: context }
     );
     return rendered;;
};